import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { reconnectBranddotcomOtas } from 'lumen/utils/disconnected-otas';

export default class HotelParityRoute extends Route {
  @service access;
  @service router;
  @service store;

  deactivate() {
    reconnectBranddotcomOtas(this.store);

    /**
     * In application tests, the app gets torn down after each test. This causes the store to be destroyed
     * before the deactivate hook is called. This check is to prevent the store from being accessed after it's destroyed.
     */
    if (this.store.isDestroyed) {
      return;
    }
    // this.store.unloadAll('day');
    // this.store.unloadAll('period');
    this.store.unloadAll('roomtype');
  }

  redirect(model, transition) {
    if (transition.targetName === 'hotel.parity.index') {
      // Parity insight and list are the default views
      if (this.access.hasParityAnalytics) {
        this.router.transitionTo('hotel.parity.insight');
      }
      // Parity list view is the default view
      this.router.transitionTo('hotel.parity.list');
    }
  }
}
